import type { HubConnection } from '@microsoft/signalr';

export function startUserHub(hub: HubConnection, userId: string, onRejoined: () => void | Promise<void>) {
    let disposed = false;
    let retry: ReturnType<typeof setTimeout> | undefined;
    const join = async (resync: boolean) => {
        if (disposed) return;
        await hub.invoke('Join', userId);
        // Pages already load on mount. Only a reconnect needs a catch-up refresh.
        if (!disposed && resync) await onRejoined();
    };
    const rejoin = () => {
        if (!disposed) join(true).catch(() => { if (!disposed) retry = setTimeout(rejoin, 5000); });
    };
    hub.onreconnected(() => { if (retry) clearTimeout(retry); rejoin(); });
    return {
        ready: hub.start().then(() => join(false)),
        stop: () => { disposed = true; if (retry) clearTimeout(retry); return hub.stop(); },
    };
}
